module.exports = __webpack_public_path__ + "static/img/03img.f317b27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/sport/01challengeList/03img.png
// module id = dMXD
// module chunks = 0